<template>
<div style="height:100%">
<div style="display: flex;align-items: center;justify-content: center;height: 100%;">
    <label v-if="!tcSubmitted">
        <input type="checkbox" v-model="acceptTerms" />
        Accept terms and conditions
    </label>
</div>
<div class="consultant-form" v-if="tcSubmitted">
    <!-- <h2>PC to Consultant</h2> -->
    <KycInfo :showTitle="false" @validationStatus="handleValidationStatus('userKycForm', $event)" ref="userKycForm" />
</div>
<!-- {{ aadhaarVerified }} -->
<button
v-if="tcSubmitted && acceptTerms"
     class="btn submit_btn full-width"
     style="position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);"
     :disabled="!aadhaarVerified"
     @click="saveChanges" 
    >Save Changes
</button>
<!-- Submit Button -->
<button
    v-else
    class="btn submit_btn full-width"
    style="position: absolute; bottom: -5px; left: 50%; transform: translateX(-50%);"
    :disabled="!acceptTerms"
    @click="handleSubmit"
  >
    Submit
  </button>
</div>
<!-- <div class="form-actions">
    <button @click="saveChanges" :disabled="!showBtn" v-if="!hide_save_in.includes(activeTab)" class="save-button">Save Changes</button>
</div> -->
</template>
<script setup>
import { useUserStore } from '@/stores/userStore';
import KycInfo from '../forms/KycInfo.vue';
import { computed,ref,watch } from 'vue';
import { useUsers } from '@/composables/useUsers';
import eventBus from '@/utils/eventBus';
import userService from '@/services/userServices';
const userStore = useUserStore();
const accessToken = computed(() => userStore.getAccessToken);
const mca_no = computed(() => userStore.getmca_no);
const aadharId = ref('');
const aadhaarVerified = ref(false);
const acceptTerms = ref(false);
const tcSubmitted = ref(false);
const userKycForm = ref(null);
const formStatuses = ref({userKycForm: { isValid: false, errors: {} },});
function handleValidationStatus(formName, { isValid, errors }) {
    formStatuses.value[formName] = { isValid, errors };
}

function handleSubmit() {
  if (acceptTerms.value) {
    tcSubmitted.value = true; // Show the "Save Changes" button
  }
}
const saveChanges=async ()=> {
// const kycFormData = await userKycForm.value.getFormData();
// console.log(kycFormData,'this is the form data aadhar')
// if (kycFormData) {
    //         console.log(kycFormData);
    let kycFormData= await validateKyc();
    if (kycFormData.kyc_no) {
        await handlepcToconsultant();
        // if (kycFormData.kyc_no != null) {
            aadharId.value = kycFormData.kyc_no;
            aadhaarVerified.value = true;
            let requestData = {
                kyc_no: kycFormData.kyc_no,
                type: 1
            };
            updateSecond(requestData).then(userStore.setKycAvailable(true)).then(eventBus.panelClose()).then(window.location.reload());
        }
    // }
// }
}
const validateFormComponent = (formRef) => {
            return new Promise((resolve, reject) => {
                if (formRef.value) {
                    let formData = formRef.value.getFormData();
                    if (formData) {
                        resolve(formData); // Return form data if valid
                    } else {
                        reject('Form Not Filled'); // Reject if the form is invalid
                    }
                } else {
                    resolve(null); // If form is not visible, resolve with null
                }
            });
        };
const validateKyc=async ()=>{
    // Validate KYC Info
    const kycFormData = await validateFormComponent(userKycForm);
    if (kycFormData) {
        aadharId.value=kycFormData.aadhaarId;
        aadhaarVerified.value = true;
    }
    return kycFormData;
}
const {pcToconsultant } = useUsers();
const handlepcToconsultant = async () => {
      try {
        const result = await pcToconsultant(mca_no.value, aadharId.value);
        console.log(result); // 'PAN not Verified' if false, else API response
      } catch (error) {
        console.error('Error handlepcToconsultant:', error);
      }
    };
const updateSecond=async (requestData)=> {
          try {
            const response = await userService.updateUserProfile(accessToken.value, requestData);
            // this.populateData(response.user);
            console.log('Address details updated:', response.user);
            return true;
          } catch (error) {
            console.error('Error updating address details:', error);
            throw error;
          }
        }
watch(
  () => userKycForm.value?.isFormValid,
  async(newVal) => {
    if (newVal) {
    let kycFormData=await validateKyc();
        aadharId.value = kycFormData.kyc_no;
            aadhaarVerified.value = true;
      } 
  },
  { immediate: true } // You can use this to run the watcher immediately on component mount
);
</script>
<style scoped>
.consultant-form {
    max-width: 800px;
    /* margin: 20px auto; */
    background-color: #fff;
    padding: 10px 35px;
    border-radius: 8px;
    text-align: left;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.submit_btn{
    display: flex;
    justify-content: center;
    gap: 10px;
    /* background-color: #2c2c2c; */
    background-color: #006ea5;
    border-radius: 10px;
    color: #fff;
    height: 45px;
    width: 150px;
    align-items: center;
    cursor: pointer;
    user-select: none;
}
.submit_btn:hover{
    color:white;
}
</style>